(() => {
  if (window.__bbProductDescriptionInitialized) return;
  window.__bbProductDescriptionInitialized = true;

  const headingGroups = new Map([
    ['about this product', 'about'],
    ['description', 'about'],
    ['product description', 'about'],
    ['features', 'about'],
    ['feature', 'about'],
    ['key features', 'about'],
    ['highlights', 'about'],

    ['product details', 'details'],
    ['product information', 'details'],
    ['pack size', 'details'],
    ['package size', 'details'],
    ['size', 'details'],
    ['package information', 'details'],
    ['packaging', 'details'],
    ['storage type', 'details'],
    ['storage', 'details'],
    ['country', 'details'],
    ['country of origin', 'details'],
    ['provenance', 'details'],
    ['additional information', 'details'],

    ['ingredients', 'ingredients'],
    ['ingredient', 'ingredients'],
    ['allergens', 'ingredients'],
    ['allergen information', 'ingredients'],
    ['allergy information', 'ingredients'],
    ['allergy advice', 'ingredients'],
    ['dietary information', 'ingredients'],
    ['nutritional information', 'ingredients'],
    ['nutrition information', 'ingredients'],

    ['preparation and usage', 'usage'],
    ['preparation & usage', 'usage'],
    ['directions', 'usage'],
    ['usage', 'usage'],
    ['how to use', 'usage'],
    ['safety warning', 'usage'],
    ['safety warnings', 'usage'],
    ['safety information', 'usage'],
    ['warning', 'usage'],
    ['warnings', 'usage'],
    ['clp regulation', 'usage'],

    ['manufacturer', 'manufacturer'],
    ['manufacturer address', 'manufacturer'],
    ['company name', 'manufacturer'],
    ['company address', 'manufacturer'],
    ['telephone helpline', 'manufacturer'],
    ['helpline', 'manufacturer'],
    ['web address', 'manufacturer'],
    ['return to', 'manufacturer'],
    ['contact information', 'manufacturer'],
    ['customer care', 'manufacturer'],
    ['disclaimer', 'manufacturer'],
    ['important information', 'manufacturer'],
  ]);

  const groupLabels = {
    details: 'Product details',
    ingredients: 'Ingredients / allergens',
    usage: 'Usage / safety information',
    manufacturer: 'Manufacturer & important information',
  };

  function normalizeHeading(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/[:.]+$/, '')
      .trim()
      .toLowerCase();
  }

  function getHeadingGroup(node) {
    if (!(node instanceof Element)) return null;
    const normalized = normalizeHeading(node.textContent);
    if (!normalized || !headingGroups.has(normalized)) return null;

    const tagName = node.tagName.toLowerCase();
    const isHeading = /^h[1-6]$/.test(tagName);
    const isShortBlock = ['p', 'div', 'strong', 'b'].includes(tagName) && normalized.length <= 42;
    return isHeading || isShortBlock ? headingGroups.get(normalized) : null;
  }

  function removeEmptyMarkup(root) {
    if (!(root instanceof Element)) return;

    root
      .querySelectorAll('.source-inline-chip-container, .luminous-sources')
      .forEach((element) => element.remove());

    root.querySelectorAll('[class*="citation-"]').forEach((element) => {
      element.replaceWith(...element.childNodes);
    });

    root.querySelectorAll('sup.superscript').forEach((element) => {
      if (!element.textContent.trim()) element.remove();
    });

    Array.from(root.querySelectorAll('p, div, span')).reverse().forEach((element) => {
      const hasContent = element.textContent.trim() || element.querySelector('img, video, table, iframe');
      if (!hasContent) element.remove();
    });
  }

  function cleanClone(node) {
    const clone = node.cloneNode(true);

    if (clone instanceof Element) {
      removeEmptyMarkup(clone);
      const hasContent = clone.textContent.trim() || clone.querySelector('img, video, table, iframe, ul, ol');
      return hasContent ? clone : null;
    }

    if (clone.nodeType === Node.TEXT_NODE && !clone.textContent.trim()) return null;
    return clone;
  }

  function createSubheading(text) {
    const heading = document.createElement('h3');
    heading.className = 'bb-product-description__subheading';
    heading.textContent = String(text || '').replace(/\s+/g, ' ').trim().replace(/:$/, '');
    return heading;
  }

  function appendNodes(target, nodes) {
    nodes.forEach((node) => target.appendChild(node));
  }

  function createAccordion(group, nodes) {
    const details = document.createElement('details');
    details.className = 'bb-product-description__accordion';
    details.dataset.bbDescriptionGroup = group;

    const summary = document.createElement('summary');
    summary.className = 'bb-product-description__summary';

    const title = document.createElement('span');
    title.className = 'bb-product-description__summary-title';
    title.textContent = groupLabels[group];

    const panel = document.createElement('div');
    panel.className = 'bb-product-description__panel rte';
    appendNodes(panel, nodes);

    summary.appendChild(title);
    details.append(summary, panel);
    return details;
  }

  function enhanceDescription(container) {
    if (!(container instanceof Element) || container.dataset.bbDescriptionEnhanced === 'true') return;

    const groups = {
      about: [],
      details: [],
      ingredients: [],
      usage: [],
      manufacturer: [],
    };

    let currentGroup = 'about';

    Array.from(container.childNodes).forEach((node) => {
      const nextGroup = getHeadingGroup(node);

      if (nextGroup) {
        currentGroup = nextGroup;
        groups[currentGroup].push(createSubheading(node.textContent));
        return;
      }

      const clone = cleanClone(node);
      if (clone) groups[currentGroup].push(clone);
    });

    const fragment = document.createDocumentFragment();
    const about = document.createElement('div');
    about.className = 'bb-product-description__about rte';
    appendNodes(about, groups.about);
    fragment.appendChild(about);

    const accordionList = document.createElement('div');
    accordionList.className = 'bb-product-description__accordions';

    ['details', 'ingredients', 'usage', 'manufacturer'].forEach((group) => {
      if (groups[group].length) accordionList.appendChild(createAccordion(group, groups[group]));
    });

    if (accordionList.children.length) fragment.appendChild(accordionList);

    container.replaceChildren(fragment);
    container.classList.remove('rte');
    container.classList.add('bb-product-description__source--enhanced');
    container.dataset.bbDescriptionEnhanced = 'true';
  }

  function initializeDescriptions(scope = document) {
    if (scope.matches?.('[data-bb-product-description]')) enhanceDescription(scope);
    scope.querySelectorAll?.('[data-bb-product-description]').forEach(enhanceDescription);
  }

  function positionRecommendations() {
    const slot = document.querySelector('[data-bb-recommendations-slot]');
    if (!slot) return;

    const recommendations = Array.from(
      document.querySelectorAll('product-recommendations[data-bb-related-products]')
    ).find((element) => !slot.contains(element));

    if (!recommendations) return;

    const sourceSection = recommendations.closest('.shopify-section');
    slot.replaceChildren(recommendations);

    if (sourceSection && !sourceSection.contains(recommendations)) {
      sourceSection.hidden = true;
      sourceSection.dataset.bbRecommendationsSource = 'true';
    }
  }

  function initializeProductContent(scope = document) {
    initializeDescriptions(scope);
    positionRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeProductContent());
  } else {
    initializeProductContent();
  }

  document.addEventListener('shopify:section:load', (event) => initializeProductContent(event.target));
})();
